import { ReactNode } from 'react';

import { ErrorMessage, FormFieldRoot } from './styles';

export type FormFieldProps<T> = T & {
  className?: string;
  error?: string;
  hideErrorMessage?: boolean;
  touched?: boolean;
  children: ReactNode;
  fullWidth?: boolean;
};

export const FormField = <T extends object>({ className, error, touched, children, hideErrorMessage, fullWidth }: FormFieldProps<T>) => (
  <FormFieldRoot fullWidth={fullWidth} className={className} error={Boolean(error)} touched={touched}>
    {children}
    <ErrorMessage visible={Boolean(error && !hideErrorMessage)}>{error}</ErrorMessage>
  </FormFieldRoot>
);
